import React, { useState } from 'react';
import { Search, MessageSquare, UserX, AlertTriangle, Eye, Download, CheckCircle2, Clock, Ban } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
interface AdminChatMonitorProps {
  chats: any[];
  setActiveTab: (tab: string) => void;
  setDetailPanel: (panel: any) => void;
  success: (msg: string) => void;
}
export function AdminChatMonitor({
  chats,
  setActiveTab,
  setDetailPanel,
  success
}: AdminChatMonitorProps) {
  const [searchQuery, setSearchQuery] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState({
    status: 'all',
    riskFlag: 'all'
  });
  const [selectedChat, setSelectedChat] = useState<any | null>(null);
  // Mock chat history for detail view
  const mockChatHistory = [{
    id: 1,
    sender: 'user',
    text: 'Здравствуйте! Я оплатил заказ #1042',
    time: '10:00',
    date: 'Сегодня'
  }, {
    id: 2,
    sender: 'astrologer',
    text: 'Добрый день! Вижу вашу оплату. Приступаю к работе.',
    time: '10:05',
    date: 'Сегодня'
  }, {
    id: 3,
    sender: 'astrologer',
    text: 'Для составления карты мне нужно точное время рождения.',
    time: '10:06',
    date: 'Сегодня'
  }, {
    id: 4,
    sender: 'user',
    text: '14:30. А можно вам в whatsapp написать? Там быстрее.',
    time: '10:15',
    date: 'Сегодня',
    risk: true,
    riskType: 'whatsapp'
  }, {
    id: 5,
    sender: 'astrologer',
    text: 'Да, конечно, пишите: +79991234567',
    time: '10:18',
    date: 'Сегодня',
    risk: true,
    riskType: 'phone'
  }];
  const renderKpiCard = (label: string, value: string | number, icon: React.ReactNode, bgClass: string, textClass: string) => <Card padding="sm" className="rounded-xl shadow-none border-slate-200 p-4 flex items-center gap-4" data-id="element-2529">
      <div className={`w-10 h-10 rounded-xl ${bgClass} flex items-center justify-center flex-shrink-0`} data-id="element-2530">
        {icon}
      </div>
      <div data-id="element-2531">
        <div className="text-xs text-slate-500 font-medium mb-0.5" data-id="element-2532">{label}</div>
        <div className={`text-xl font-bold ${textClass}`} data-id="element-2533">{value}</div>
      </div>
    </Card>;
  const filteredChats = chats.filter(c => {
    const matchesSearch = c.id?.toLowerCase().includes(searchQuery.toLowerCase()) || c.user?.toLowerCase().includes(searchQuery.toLowerCase()) || c.astrologer?.toLowerCase().includes(searchQuery.toLowerCase());
    if (!matchesSearch) return false;
    if (filters.status !== 'all' && c.status !== filters.status) return false;
    if (filters.riskFlag !== 'all') {
      const hasRisk = !!c.riskFlag;
      if (filters.riskFlag === 'true' && !hasRisk) return false;
      if (filters.riskFlag === 'false' && hasRisk) return false;
    }
    return true;
  });
  if (selectedChat) {
    return <div className="space-y-4" data-id="element-2534">
        <div className="flex items-center gap-4 mb-2" data-id="element-2535">
          <Button variant="ghost" size="sm" onClick={() => setSelectedChat(null)} data-id="element-2536">
            ← Назад к списку
          </Button>
          <h2 className="text-xl font-bold text-slate-900" data-id="element-2537">
            Чат {selectedChat.id}
          </h2>
          {selectedChat.riskFlag && <Badge variant="error" data-id="element-2538">Risk Flag Detected</Badge>}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-2539">
          <div className="lg:col-span-2" data-id="element-2540">
            <Card padding="md" className="rounded-xl shadow-none border-slate-200 h-[600px] flex flex-col" data-id="element-2541">
              <div className="flex justify-between items-center mb-4 pb-4 border-b border-slate-100" data-id="element-2542">
                <div className="flex items-center gap-2" data-id="element-2543">
                  <div className="relative" data-id="element-2544">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" data-id="element-2545" />
                    <input type="text" placeholder="Поиск по словам..." className="pl-9 pr-4 py-1.5 text-sm border border-slate-200 rounded-lg focus:outline-none focus:border-indigo-500" data-id="element-2546" />
                  </div>
                </div>
                <div className="flex gap-2" data-id="element-2547">
                  <Button variant="outline" size="sm" icon={<AlertTriangle className="w-4 h-4" data-id="element-2549" />} className="text-amber-600 border-amber-200" onClick={() => success('Предупреждение отправлено')} data-id="element-2548">
                    Предупредить
                  </Button>
                  <Button variant="outline" size="sm" icon={<Ban className="w-4 h-4" data-id="element-2551" />} className="text-rose-600 border-rose-200" onClick={() => success('Чат заблокирован')} data-id="element-2550">
                    Заблокировать чат
                  </Button>
                </div>
              </div>

              <div className="flex-grow overflow-y-auto space-y-4 pr-2" data-id="element-2552">
                {mockChatHistory.map(msg => <div key={msg.id} className={`flex flex-col ${msg.sender === 'user' ? 'items-end' : 'items-start'}`} data-id="element-2553">
                    <div className="flex items-baseline gap-2 mb-1" data-id="element-2554">
                      <span className="text-xs font-bold text-slate-700" data-id="element-2555">
                        {msg.sender === 'user' ? selectedChat.user : selectedChat.astrologer}
                      </span>
                      <span className="text-[10px] text-slate-400" data-id="element-2556">
                        {msg.date}, {msg.time}
                      </span>
                    </div>
                    <div className={`max-w-[80%] p-3 rounded-2xl text-sm ${msg.risk ? 'bg-rose-50 border-2 border-rose-200 text-rose-900 shadow-sm' : msg.sender === 'user' ? 'bg-indigo-50 text-indigo-900' : 'bg-slate-100 text-slate-900'}`} data-id="element-2557">
                      {msg.risk && <div className="flex items-center gap-1.5 text-[10px] font-bold text-rose-600 mb-1.5 uppercase tracking-wider bg-rose-100/50 inline-block px-2 py-0.5 rounded" data-id="element-2558">
                          <AlertTriangle className="w-3 h-3 inline pb-0.5" data-id="element-2559" />
                          Нарушение:{' '}
                          {msg.riskType === 'whatsapp' ? 'Упоминание мессенджера' : 'Обмен контактами'}
                        </div>}
                      <div data-id="element-2560">{msg.text}</div>
                    </div>
                  </div>)}
              </div>
            </Card>
          </div>

          <div className="space-y-4" data-id="element-2561">
            <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-2562">
              <h3 className="text-sm font-bold text-slate-900 mb-4" data-id="element-2563">
                Информация
              </h3>
              <div className="space-y-4" data-id="element-2564">
                <div data-id="element-2565">
                  <div className="text-xs text-slate-500 mb-1" data-id="element-2566">
                    Пользователь
                  </div>
                  <div className="font-medium text-sm text-indigo-600 cursor-pointer hover:underline" onClick={() => setActiveTab('users')} data-id="element-2567">
                    {selectedChat.user}
                  </div>
                </div>
                <div data-id="element-2568">
                  <div className="text-xs text-slate-500 mb-1" data-id="element-2569">Астролог</div>
                  <div className="font-medium text-sm text-indigo-600 cursor-pointer hover:underline" onClick={() => setActiveTab('astrologers')} data-id="element-2570">
                    {selectedChat.astrologer}
                  </div>
                </div>
                <div data-id="element-2571">
                  <div className="text-xs text-slate-500 mb-1" data-id="element-2572">
                    Связанный заказ
                  </div>
                  <div className="font-medium text-sm text-indigo-600 cursor-pointer hover:underline" onClick={() => setActiveTab('orders')} data-id="element-2573">
                    {selectedChat.orderId}
                  </div>
                </div>
                <div data-id="element-2574">
                  <div className="text-xs text-slate-500 mb-1" data-id="element-2575">Статус</div>
                  <Badge variant={selectedChat.status === 'active' ? 'success' : 'neutral'} data-id="element-2576">
                    {selectedChat.status === 'active' ? 'Активен' : 'Закрыт'}
                  </Badge>
                </div>
              </div>
            </Card>

            <Card padding="md" className="rounded-xl shadow-none border-slate-200 bg-rose-50/30" data-id="element-2577">
              <h3 className="text-sm font-bold text-rose-900 mb-2 flex items-center gap-2" data-id="element-2578">
                <AlertTriangle className="w-4 h-4" data-id="element-2579" /> Авто-анализ
              </h3>
              <p className="text-xs text-rose-700 mb-4" data-id="element-2580">
                Система обнаружила попытку обмена контактами. Астролог
                согласился перейти в сторонний мессенджер.
              </p>
              <div className="space-y-2" data-id="element-2581">
                <Button variant="outline" size="sm" className="w-full text-rose-600 border-rose-200 bg-white" onClick={() => success('Штраф начислен')} data-id="element-2582">
                  Оштрафовать астролога
                </Button>
                <Button variant="outline" size="sm" className="w-full text-slate-600 bg-white" onClick={() => success('Флаг снят')} data-id="element-2583">
                  Ложное срабатывание (Снять флаг)
                </Button>
              </div>
            </Card>
          </div>
        </div>
      </div>;
  }
  return <div className="space-y-6" data-id="element-2584">
      <div className="flex justify-between items-center" data-id="element-2585">
        <h2 className="text-xl font-bold text-slate-900" data-id="element-2586">Центр коммуникаций</h2>
        <Button variant="outline" size="sm" icon={<Download className="w-4 h-4" data-id="element-2588" />} onClick={() => success('Экспорт начат')} data-id="element-2587">
          Экспорт логов
        </Button>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-2589">
        {renderKpiCard('Всего чатов', '8,452', <MessageSquare className="w-5 h-5 text-indigo-600" data-id="element-2590" />, 'bg-indigo-50', 'text-slate-900')}
        {renderKpiCard('Активные сейчас', '142', <Clock className="w-5 h-5 text-blue-600" data-id="element-2591" />, 'bg-blue-50', 'text-slate-900')}
        {renderKpiCard('Risk Диалоги', '15', <AlertTriangle className="w-5 h-5 text-rose-600" data-id="element-2592" />, 'bg-rose-50', 'text-rose-600')}
        {renderKpiCard('С жалобами', '8', <AlertTriangle className="w-5 h-5 text-amber-600" data-id="element-2593" />, 'bg-amber-50', 'text-amber-600')}
      </div>

      {/* Table Section */}
      <Card padding="none" className="rounded-xl shadow-none border-slate-200 overflow-hidden" data-id="element-2594">
        <div className="p-4 border-b border-slate-100 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 bg-slate-50/50" data-id="element-2595">
          <div className="flex items-center gap-3 w-full sm:w-auto" data-id="element-2596">
            <div className="relative flex-1 sm:w-64" data-id="element-2597">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" data-id="element-2598" />
              <input type="text" placeholder="Поиск по ID, пользователю..." className="w-full pl-9 pr-4 py-2 text-sm border border-slate-200 rounded-lg focus:outline-none focus:border-indigo-500 bg-white" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-2599" />
            </div>
            <Button variant={showFilters ? 'primary' : 'outline'} size="sm" icon={<Search className="w-4 h-4" data-id="element-2601" />} onClick={() => setShowFilters(!showFilters)} data-id="element-2600">
              Фильтры
            </Button>
          </div>
          <div className="flex gap-2" data-id="element-2602">
            <Badge variant={filters.status === 'all' && filters.riskFlag === 'all' ? 'primary' : 'neutral'} className="cursor-pointer hover:bg-slate-200" onClick={() => setFilters({
            ...filters,
            status: 'all',
            riskFlag: 'all'
          })} data-id="element-2603">
              Все
            </Badge>
            <Badge variant={filters.riskFlag === 'true' ? 'error' : 'neutral'} className="cursor-pointer hover:bg-rose-100 bg-white" onClick={() => setFilters({
            ...filters,
            status: 'all',
            riskFlag: 'true'
          })} data-id="element-2604">
              Risk Flags
            </Badge>
            <Badge variant={filters.status === 'active' ? 'warning' : 'neutral'} className="cursor-pointer hover:bg-amber-100 bg-white" onClick={() => setFilters({
            ...filters,
            status: 'active',
            riskFlag: 'all'
          })} data-id="element-2605">
              Активные
            </Badge>
          </div>
        </div>

        {/* Advanced Filters Panel */}
        {showFilters && <div className="p-4 border-b border-slate-100 bg-white space-y-4 animate-in slide-in-from-top-2" data-id="element-2606">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3" data-id="element-2607">
              <div data-id="element-2608">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-2609">
                  Статус
                </label>
                <select className="w-full rounded-lg border border-slate-200 bg-white text-sm py-2 px-3 focus:outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500" value={filters.status} onChange={e => setFilters({
              ...filters,
              status: e.target.value
            })} data-id="element-2610">
                  <option value="all" data-id="element-2611">Все</option>
                  <option value="active" data-id="element-2612">Активные</option>
                  <option value="closed" data-id="element-2613">Завершенные</option>
                </select>
              </div>
              <div data-id="element-2614">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-2615">
                  Risk Flag
                </label>
                <select className="w-full rounded-lg border border-slate-200 bg-white text-sm py-2 px-3 focus:outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500" value={filters.riskFlag} onChange={e => setFilters({
              ...filters,
              riskFlag: e.target.value
            })} data-id="element-2616">
                  <option value="all" data-id="element-2617">Все</option>
                  <option value="true" data-id="element-2618">Есть</option>
                  <option value="false" data-id="element-2619">Нет</option>
                </select>
              </div>
              <div className="flex items-end" data-id="element-2620">
                <Button variant="ghost" size="sm" onClick={() => setFilters({
              status: 'all',
              riskFlag: 'all'
            })} data-id="element-2621">
                  Сбросить
                </Button>
              </div>
            </div>
          </div>}

        <div className="overflow-x-auto" data-id="element-2622">
          <table className="w-full text-left" data-id="element-2623">
            <thead className="bg-slate-50 text-slate-500 border-b border-slate-200 text-xs uppercase tracking-wider" data-id="element-2624">
              <tr data-id="element-2625">
                <th className="px-4 py-3 font-medium" data-id="element-2626">ID / Дата</th>
                <th className="px-4 py-3 font-medium" data-id="element-2627">Пользователь</th>
                <th className="px-4 py-3 font-medium" data-id="element-2628">Астролог</th>
                <th className="px-4 py-3 font-medium" data-id="element-2629">Сообщений</th>
                <th className="px-4 py-3 font-medium" data-id="element-2630">Статус</th>
                <th className="px-4 py-3 font-medium text-center" data-id="element-2631">Risk Flag</th>
                <th className="px-4 py-3 text-right" data-id="element-2632">Действия</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-2633">
              {filteredChats.map(c => <tr key={c.id} className="hover:bg-slate-50 transition-colors cursor-pointer" onClick={() => setSelectedChat(c)} data-id="element-2634">
                  <td className="px-4 py-3" data-id="element-2635">
                    <div className="text-xs font-bold text-slate-900" data-id="element-2636">
                      {c.id}
                    </div>
                    <div className="text-[10px] text-slate-500" data-id="element-2637">{c.date}</div>
                  </td>
                  <td className="px-4 py-3" data-id="element-2638">
                    <div className="text-sm font-medium text-slate-900" data-id="element-2639">
                      {c.user}
                    </div>
                    <div className="text-xs text-slate-500" data-id="element-2640">
                      Астролог: {c.astrologer}
                    </div>
                  </td>
                  <td className="px-4 py-3" data-id="element-2641">
                    <div className="text-sm text-slate-600 truncate max-w-[250px]" data-id="element-2642">
                      {c.lastMessage}
                    </div>
                    <div className="text-[10px] text-slate-400" data-id="element-2643">
                      {c.msgCount} сообщений
                    </div>
                  </td>
                  <td className="px-4 py-3 text-xs text-indigo-600 hover:underline" onClick={e => {
                e.stopPropagation();
                setActiveTab('orders');
              }} data-id="element-2644">
                    {c.orderId}
                  </td>
                  <td className="px-4 py-3" data-id="element-2645">
                    <Badge variant={c.status === 'active' ? 'success' : 'neutral'} size="sm" data-id="element-2646">
                      {c.status === 'active' ? 'Активен' : 'Закрыт'}
                    </Badge>
                  </td>
                  <td className="px-4 py-3 text-center" data-id="element-2647">
                    {c.riskFlag ? <Badge variant="error" size="sm" className="px-1.5 py-0 text-[10px]" data-id="element-2648">
                        High Risk
                      </Badge> : c.complaints ? <Badge variant="warning" size="sm" className="px-1.5 py-0 text-[10px]" data-id="element-2649">
                        Жалоба
                      </Badge> : <span className="text-slate-300" data-id="element-2650">-</span>}
                  </td>
                  <td className="px-4 py-3 text-right" data-id="element-2651">
                    <Button variant="ghost" size="sm" className="w-8 h-8 p-0 text-slate-400 hover:text-indigo-600" data-id="element-2652">
                      <Eye className="w-4 h-4" data-id="element-2653" />
                    </Button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}